import isServer from '../isServer';

// isDesktop is a util to check whether in the desktop environment (set in initDesktop util)
// - can only be used on the client, this is a good way to safeguard window.Bridge functions
// - not ideal for whether to render html because will always return false on the server
export default function isDesktop() {
  return !isServer() && window.isElectron && window.isElectron();
}
